export interface MCBNS010AutoReservationRemindInfo {
  autoReservationRemindList: AutoReservationRemindInfoDto[]
}


export interface AutoReservationRemindInfoDto {
  seminarId: number;// セミナーID
  coordinationFormerSeminarId: string;// 連携元セミナーID
  seminarName: string;// セミナー名
  publicFlag: string;// 公開フラグ
  studentDisplayEnd: boolean // 学生に表示される期間終わったフラグ
  displayStartDate: Date;// 表示開始日
  displayEndDate: Date;// 表示終了日
  deliveryPreference: string;// 配信設定
  templateName1: string;// テンプレート名1
  templateName2: string;// テンプレート名2
  deliveryTiming1: string;// 配信タイミング1
  deliveryTiming2: string;// 配信タイミング2
  updateTime: Date;// 更新日時
  updater: string;// 更新者
}

export const initialMCBNS010AutoReservationRemindInfo: MCBNS010AutoReservationRemindInfo = {
  autoReservationRemindList: [],
}